// extracted by mini-css-extract-plugin
export default {"inputBorderRadius":"auto","fontSize":"14px","navYBorderHover":"4px solid #c3daed","navYBorderSelected":"4px solid #619fd0","navYBackgroundSelected":"#f6f9fb"};